module.exports = __webpack_public_path__ + "img/image_paid.2c94ab10.png";